import React, { useState } from 'react'

import { t } from "i18next";

import { Badge, Button } from 'reactstrap';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';


export default function PlanTable({ lessons, handleChoice }) {

    const getBadge = (status) => {
        if (status == 1) {
            return (
                <Badge color="light-success" pill>
                    {t('Үзcэн')}
                </Badge>
            )
        } else if(status == 2) {
            return (
                <Badge color="light-danger" pill>
                    {t('Үзээгүй')}
                </Badge>
            )
        } else {
            return (
                <Badge color="light-primary" pill>
                    {t('Үзэж байгаа')}
                </Badge>
            )
        }
    }

    return (
        <TableContainer component={Paper} className="mb-1">
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead >
                    <TableRow
                        sx={
                            {
                                "& th": {
                                    color: "white",
                                    fontSize: "14px",
                                    padding: "10px",
                                    backgroundColor: "#457b9d"
                                }
                            }
                        }
                    >
                        <TableCell>№</TableCell>
                        <TableCell>{t('Хичээлийн код')}</TableCell>
                        <TableCell>{t('Хичээлийн нэр')}</TableCell>
                        <TableCell>{t('Өмнөх холбоо')}</TableCell>
                        <TableCell>{t('Кредит')}</TableCell>
                        <TableCell>{t('Дүн')}</TableCell>
                        <TableCell>{t('Улирал')}</TableCell>
                        <TableCell>{t('Статус')}</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {lessons.map((row, idx) => (
                        <TableRow
                            key={idx}
                        >
                            <TableCell >{idx + 1}</TableCell>
                            <TableCell>
                                {row?.code}
                            </TableCell>
                            <TableCell>
                                {/* <a href={process.env.REACT_APP_SERVER_URL+''+row?.lesson_pdf} target='_blank' className={row?.score ? 'link-primary text-decoration-underline' : ''}>{row?.name}</a> */}
                                {
                                    row?.lesson_pdf
                                    ?
                                        <a href={process.env.REACT_APP_SERVER_URL+''+row?.lesson_pdf} target='_blank' className={row?.score ? 'link-primary text-decoration-underline' : ''}>{row?.name}</a>
                                    :
                                        row?.name
                                }
                            </TableCell>
                            <TableCell>
                                {row?.previous_lesson && row?.previous_lesson?.code}
                            </TableCell>
                            <TableCell >{row?.kredit}</TableCell>
                            <TableCell >{row?.score}</TableCell>
                            <TableCell>{row?.season}</TableCell>
                            <TableCell>
                                {getBadge(row?.status)}
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    )
}
